import {detectWebGLSupport} from './core/utils/webgl-detector';

export const DOCUMENTATION_LINK: string = 'https://doc.maxoptra.com';
export const DOCUMENTATION_LINK_WITH_AUTH: string = 'https://maxoptra:l3tm31n@doc.maxoptra.com';
export const DOCUMENTATION_ASSESTS: string = 'https://customer-documentation-assets.s3.eu-west-2.amazonaws.com';
export const DEFAULT_LANG = 'en';
export const APP_EMBEDDED = () => window && window.parent != window;
export const APP_DISABLED_PLANNING = false;

export const USE_TABLE_VIEW = true;
export const USE_WEBGL = detectWebGLSupport();
export const USE_CONSIGNMENT = true;
export const ICONS_SIZE_MULTIPLIER = 1;
export const USE_ICONS_CACHE = false;
export const USE_EASY_SELECTION = false;
export const USE_DBL_BUFFERING = true;
export const BASE_URL = () => ('ASSETS_URL' in window ? window['ASSETS_URL'] : document.location.origin + '/');

export const SESSION_KEEP_ALIVE_INTERVAL = 1000 * 60 * 5;

export const MAP_MARKER_MIN_DISPLACEMENT = 0.5;
